import { useThemeState } from "../../redux/reducers/themeReducer";
import { useThemeActions } from "../../redux/actions/themeActions";

export type ThemeService = {
    isDarkTheme: boolean;
    isLightTheme: boolean;
    isAutoTheme: boolean;
    switchToLightTheme: () => void;
    switchToDarkTheme: () => void;
    flipTheme: () => void;
    setToAutoTheme: (isDark?: boolean) => void;
}

export const useThemeService = (): ThemeService => {

    //Hooks
    const themeState = useThemeState();
    const themeActions = useThemeActions();

    //Logic
    const switchToLightTheme = () => {
        themeActions.setDarkTheme(false);
    }
    const switchToDarkTheme = () => {
        themeActions.setDarkTheme(true);
    }
    const flipTheme = () => {
        themeActions.setAutoTheme(false);
        if (themeState.isDarkTheme) switchToLightTheme();
        else switchToDarkTheme();
    }
    const setToAutoTheme = (isDark?: boolean) => {
        const isAutoDark = isDark ?? window.matchMedia("(prefers-color-scheme: dark)").matches;
        themeActions.setAutoTheme(true);
        if (isAutoDark) switchToLightTheme();
        else switchToDarkTheme();
    }

    return {
        isDarkTheme: !!themeState.isDarkTheme,
        isLightTheme: !themeState.isDarkTheme,
        isAutoTheme: !!themeState.isAutoTheme,
        switchToDarkTheme,
        switchToLightTheme,
        flipTheme,
        setToAutoTheme
    }
}
